import React from "react";
import { Container, Spinner } from "reactstrap";

interface PageLoaderProps {
  /** Shown below the spinner. Default: "Loading..." */
  message?: string;
}

const PageLoader = ({ message = "Loading..." }: PageLoaderProps) => {
  return (
    <div className="page-content">
      <Container
        fluid
        className="d-flex flex-column align-items-center justify-content-center text-muted"
        style={{ minHeight: "min(50vh, 320px)" }}
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label={message}
      >
        <Spinner animation="border" color="primary" className="mb-3" />
        <span className="small">{message}</span>
      </Container>
    </div>
  );
};

export default PageLoader;
